<template>
  <div id="signup">
     <body class="login-page err-500">
          <div class="container">
            <div class="login-container">
                <div class="row">
                    <div class="col-lg-4 col-md-5 col-sm-9 lfh">
                        <div class="card login-box">
                            <div class="card-body">
                                <h5 class="card-title">Sign Up</h5>
                                <form novalidate="true">
                                <p style="color:red;text-align:center">{{ errorMessage }}</p>
                                  <p v-if="errors.length">
                                  <!-- <ul>
                                  <li style='color:red' v-for="error in errors">{{ error }}</li>
                                  </ul> -->
                                  <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
                                  </p>
                                    <div class="form-group">
                                        <input type="email" class="form-control" ref="email" name="email" v-model="input.email"  id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter email" disabled>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="form-control" ref="name" name="name" v-model="input.name" id="name" aria-describedby="name" placeholder="Name">
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="form-control" ref="username" name="username" v-model="input.username" id="userName" aria-describedby="userName" placeholder="Username">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" ref="password" name="password" v-model="input.password" id="exampleInputPassword" placeholder="Password">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" ref="cnfpassword" name="cnfpassword" v-model="input.cnfpassword" id="exampleInputCnfpassword" placeholder="Confirm Password">
                                    </div>
                                    <div class="custom-control custom-checkbox form-group">
                                        <input type="checkbox" class="custom-control-input" id="termsandcond" v-on:click="checkboxClick()">
                                        <label class="custom-control-label" for="termsandcond">I Agree with <a href="/termsandcondition">Terms &amp; Policies</a></label>
                                    </div>
                                    <!--<a href="#" class="btn btn-primary">Sign Up</a>-->
                                    <button type="button" id="signup_btn" class="btn btn-primary btn-lg" v-on:click="signup()">Sign Up</button>
                                    <!--<a href="sign-in.html" class="btn btn-secondary">Sign In</a>-->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </body>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'Login',
    data () {
      return {
        errors: [],
        errorMessage: '',
        input: {
          email: '',
          name: '',
          username: '',
          password: '',
          cnfpassword: ''
        }
      }
    },
    methods: {
      signup () {
        this.errors = []
        var pass = this.input.password
        var nam = this.input.name
        var uname = this.input.username
        if (this.input.name === '') {
          this.errors.push('Name is Required')
          this.$refs.name.focus()
        } else if (nam.length < 3) {
          this.errors.push('Name must be 5 characters long')
          this.$refs.name.focus()
        } else if (this.input.username === '') {
          this.errors.push('Username is Required')
          this.$refs.username.focus()
        } else if (uname < 3) {
          this.errors.push('Username must be 5 characters long')
          this.$refs.username.focus()
        } else if (this.input.password === '') {
          this.errors.push('Password is Required')
          this.$refs.password.focus()
        } else if (pass.length < 6) {
          this.errors.push('Password must be 6 characters long')
          this.$refs.password.focus()
        } else if (this.input.cnfpassword === '') {
          this.errors.push('Confirm Password is Required')
          this.$refs.cnfpassword.focus()
        } else if (this.input.password !== this.input.cnfpassword) {
          this.errors.push('Password & Confirm Password does not matched')
          this.$refs.cnfpassword.focus()
        } else {
          var email = this.input.email
          var username = this.input.username
          var name = this.input.name
          var password = this.input.password
          var confirmpassword = this.input.cnfpassword
          axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/registration',
            {
              email: email,
              name: name,
              username: username,
              password: password,
              confirm_password: confirmpassword
            })
            .then(response => window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write&requested_capabilities=["card_payments","transfers"]&requested=true#/', '_self'))
            .catch((error) => {
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
        }
      },
      checkboxClick () {
        var checkBox = document.getElementById('termsandcond')
        if (checkBox.checked === true) {
          document.getElementById('signup_btn').disabled = false
        } else {
          document.getElementById('signup_btn').disabled = true
        }
      }
    },
    mounted () {
      document.getElementById('signup_btn').disabled = true
      var uid = this.$route.query.uid
      var self = this
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById/?uid=' + uid)
        .then(response => {
          var email = response.data.results[0].email
          localStorage.setItem('email', email)
          localStorage.setItem('uid', uid)
          self.input.email = email
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue